/* ══════════════════════════════════════════════════════════════
   Large-text mode

   In-app browsers (Messenger, Instagram, Facebook) honour the
   phone's system font size, so a visitor with large text sees the
   sticky bar overflow. This measures the real rendered size of a
   16px test string and, when it comes back noticeably larger,
   adds the class "ac-bigtext" to <html>.

   a11y-scaling.css then trims the sticky bar down to essentials,
   and the button label below is swapped for a shorter one.
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Edit these two lines to change the shortened labels ──── */
  var SHORT_BUTTON_LABEL = 'Add';
  var SCALE_THRESHOLD = 1.15; // 1.15 = 15% larger than normal

  function measureScale() {
    var probe = document.createElement('span');
    probe.textContent = 'Mg';
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = [
      'position:absolute',
      'top:-9999px',
      'left:-9999px',
      'font-size:16px',
      'line-height:1',
      'padding:0',
      'margin:0',
      'white-space:nowrap',
      'visibility:hidden'
    ].join(';');

    document.body.appendChild(probe);
    var rendered = probe.getBoundingClientRect().height;
    document.body.removeChild(probe);

    if (!rendered) return 1;
    return rendered / 16;
  }

  function shortenButtons() {
    document.querySelectorAll('[class*="pdp-sticky-btn-"]').forEach(function (btn) {
      if (btn.dataset.fullLabel) return; // already handled
      btn.dataset.fullLabel = btn.textContent.trim();
      btn.textContent = SHORT_BUTTON_LABEL;
    });
  }

  function restoreButtons() {
    document.querySelectorAll('[class*="pdp-sticky-btn-"]').forEach(function (btn) {
      if (btn.dataset.fullLabel) {
        btn.textContent = btn.dataset.fullLabel;
        delete btn.dataset.fullLabel;
      }
    });
  }

  function apply() {
    var big = measureScale() >= SCALE_THRESHOLD;
    document.documentElement.classList.toggle('ac-bigtext', big);
    if (big) {
      shortenButtons();
    } else {
      restoreButtons();
    }
  }

  function start() {
    apply();

    /* the sticky bar is rendered by the section script, so re-apply
       once it appears and whenever its contents are rewritten */
    var bar = document.querySelector('[id^="pdpStickyBar-"]');
    if (bar) {
      new MutationObserver(function () {
        if (document.documentElement.classList.contains('ac-bigtext')) {
          shortenButtons();
        }
      }).observe(bar, { childList: true, subtree: true });
    }

    window.addEventListener('resize', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
